import React from 'react';
import { useLocation } from 'react-router-dom';
import { UIScreenModal } from './ui/components/modals';
import { UIIconBtnWLabel } from './ui/components/basic';
import { UISelectLang } from './ui/components/composite';
import { useLang } from './_LangContext';
import { useNavigation } from './_NavigationContext';
import GLOBAL from '../_json/_global.json'

const HomeScreen = ({ isOpen, onClose, origin }) =>
{
	const location = useLocation();
  	const { state } = location;

	const { from } = state || {};

	const { lang, getText } = useLang();
	const { navigateWithParams, openStampcardModal } = useNavigation();

	const imgpath = process.env.PUBLIC_URL + '/img/';

	const handleOnClick = (btnKey) =>
	{
		switch(btnKey)
		{
			case 'menu':
				navigateWithParams('/menu');
				break;
			case 'map':
				navigateWithParams('/');
				break;
			case 'ar':
				navigateWithParams('/menu', { filter: 'ar' });
				break;
			case 'stampcard':
				openStampcardModal({}, { from: 'home' });
				break;
			default:
				break;
		}
	};

	const getLabelItem = (key) =>
	{
		return { [lang]: getText(key) };
	}

	const FootSteps = () =>
	{
		const footsteps = [];

		const step_num = 6;

		for(let i = 0; i < step_num; i++)
		{
			const id = (i % step_num) + 1;
			const footstep = (
				<div key={i} className={"footstep f-" + id} data-index={i}>
					<img src={imgpath + "app_logo_footstep_0" + id + ".png"} alt="" />
				</div>
			);
			footsteps.push(footstep);
		}

		return (
			<div className='footsteps'>
				{footsteps}
			</div>
		);
	}

	return (
		<UIScreenModal className="home-modal" isOpen={isOpen} onClose={onClose} from={from}>
			<div className="app-screen home">
				<div className="screen-container">
					<section className="main">
						<figure className="app-logo">
							<div className="logo-main">
								<img src={imgpath + 'app_logo_main.png'} alt={getText('app-short')} />
							</div>
							<div className="footsteps-container">
								<div className="footsteps-wrap">
									<FootSteps className="steps"/>
								</div>
							</div>
						</figure>
						<div className="block buttons">
							<UIIconBtnWLabel className="menu" iconClass="home-menu" labelTexts={getLabelItem('menu')} lang={lang} onClick={() => handleOnClick('menu')} />
							<UIIconBtnWLabel className="map" iconClass="home-map" labelTexts={getLabelItem('map')} lang={lang} onClick={() => handleOnClick('map')} />
							<UIIconBtnWLabel className="ar" iconClass="home-ar" labelTexts={getLabelItem('ar')} lang={lang} onClick={() => handleOnClick('ar')} />
							<UIIconBtnWLabel className="stampcard" iconClass="stampcard" labelTexts={getLabelItem('home-stampcard')} lang={lang} onClick={() => handleOnClick('stampcard')} />
						</div>
						<div className="block options">
							<dl>
								<dt>{getText('language')}</dt>
								<dd>
									<UISelectLang />
								</dd>
							</dl>
						</div>
					</section>
					<section className="footer">
						<p className="copyright">
							{GLOBAL.copyright}
						</p>
					</section>
				</div>
			</div>
		</UIScreenModal>
	);
};

export default HomeScreen;
